module.exports = __webpack_public_path__ + "static/media/diag1.9e4a4feb.png";